export default "/_next/static/images/circleCheckmarkBlack-f7a40d7aed29f07942a1b9b39eb5e98d.svg";